import { Component, OnInit, ViewChild } from '@angular/core';
import { centro_gasto } from '../../shared/object/centro_gasto.model';
import { SecurityService } from '../../shared/services/security.service';
import { ValidadoresService } from '../../shared/validadores/validadores';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-centro-gasto',
  templateUrl: './centro-gasto.component.html',
  styleUrls: ['./centro-gasto.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class CentroGastoComponent implements OnInit {
  private client: GraphQLClient = null;
  public formAgregarCentroGasto: FormGroup;
  public formEditarCentroGasto: FormGroup;
  public rutEmpresa;
  public sucursalCodigo;
  public listaCentroGasto:centro_gasto[];
  public centroGastoSel:centro_gasto;
  public busquedaEstado;
  public nombreBusquedaCG: string;
  @ViewChild('agregarCentroGasto', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarCentroGasto', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 18;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService) { 
      this.client = client;
      this.formAgregarCentroGasto = this.construyeFormAgrega();
      this.formEditarCentroGasto = this.construyeFormEdita();
    }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
    this.busquedaEstado = 1;
    this.nombreBusquedaCG = '';
    this.obtenerDatosCentroGasto(Number(this.rutEmpresa), Number(this.sucursalCodigo));
  }

   /***************Construccion de formularios reactivos****************/
   construyeFormAgrega() {
    return new FormGroup({
      codigo: new FormControl(0, [
        Validators.minLength(3),
        Validators.maxLength(10),
      ]),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
      ]),
      activado: new FormControl(true),
      rut_empresa: new FormControl(''),
    });
  }

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl({value: 0, disabled: true}, [
        Validators.minLength(3),
        Validators.maxLength(10),
      ]),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50),
      ]),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100),
      ]),
      activado: new FormControl(true),
      rut_empresa: new FormControl(''),
    });
  }
  /********************************************************************/

  obtenerDatosCentroGasto(rutEmpresa: number, sucursalcodigo: number) {
    const self = this; // this is unused

    this.client.query(
      {
        query: gql`
          query(
            $rut_empresa: Decimal
            $tipobusqueda: Int
            $nombre: String
          ) {
            centro_gasto {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    rut_empresa: $rut_empresa
                    tipobusqueda: $tipobusqueda
                    nombre: $nombre
                  }
                }
              ) {
                respuesta {
                  registros {
                    codigo
                    nombre
                    activado
                    descripcion
                    rut_empresa
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rutEmpresa,
          tipobusqueda: this.busquedaEstado,
          nombre: String(this.nombreBusquedaCG).toUpperCase()
        },
      },
      function (respuesta) {
        self.listaCentroGasto =
          respuesta.data.centro_gasto.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

    muestraModalAgrega() {
    this.centroGastoSel = {
      rut_empresa: null,
      codigo: null,
      descripcion: '',
      activado: true,
      nombre: null
    };
    this.formAgregarCentroGasto.reset();
  }

  insertar() {
    this.centroGastoSel = {
      codigo: this.formAgregarCentroGasto.get('codigo').value,
      nombre: this.formAgregarCentroGasto.get('nombre').value.toUpperCase() ,
      descripcion: this.formAgregarCentroGasto.get('descripcion').value.toUpperCase() ,
      activado: this.formAgregarCentroGasto.get('activado').value,
      rut_empresa: this.rutEmpresa
    };

    this.postCentroGasto(this.centroGastoSel);
  }
  postCentroGasto(nuevoCentroGasto: centro_gasto) {
    const self = this;
    const bodyx = nuevoCentroGasto;
    delete bodyx['__typename'];

    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: centro_gastoInputType) {
            centro_gasto {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  descripcion
                  activado
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.centro_gasto.guardar.respuesta == null) {
          if (respuesta.data.centro_gasto.guardar.mensajes.length > 0) {
            alert(respuesta.data.centro_gasto.guardar.mensajes[0].texto);
          }
        }

        setTimeout(
          () =>
            self.obtenerDatosCentroGasto(self.rutEmpresa, self.sucursalCodigo),
          1000
        );
      }
    );
  }
  showForEdit(cg: centro_gasto) {
    this.centroGastoSel = Object.assign({}, cg);
    this.formEditarCentroGasto.reset();
    this.formEditarCentroGasto.get('codigo').setValue(this.centroGastoSel.codigo);
    this.formEditarCentroGasto.get('nombre').setValue(this.centroGastoSel.nombre);
    this.formEditarCentroGasto.get('descripcion').setValue(this.centroGastoSel.descripcion);
    this.formEditarCentroGasto.get('activado').setValue(this.centroGastoSel.activado);
  }
  actualizar() {
    this.centroGastoSel = {
      descripcion: this.formEditarCentroGasto.get('descripcion').value.toUpperCase() ,
      codigo: this.formEditarCentroGasto.get('codigo').value,
      activado: this.formEditarCentroGasto.get('activado').value,
      nombre: this.formEditarCentroGasto.get('nombre').value.toUpperCase(),
      rut_empresa: this.rutEmpresa,
    };

    this.postCentroGasto(this.centroGastoSel);
  }

  cambiaEstado(cgSel: centro_gasto) {
    if (cgSel.activado) {
      cgSel.activado = false;
    } else {
      cgSel.activado = true;
    }
    this.postCentroGasto(cgSel);
  }
  filtraxEstado() {
    this.obtenerDatosCentroGasto(
      Number(this.rutEmpresa),
      Number(this.sucursalCodigo)
    );
  }
  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(cgSel: centro_gasto) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(cgSel);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
